import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import api from "../../api/api";
import { formatCurrency } from '../../functions/functions';
import apiFunctions from "../../api/functions.js"
import { Row, Col, Label, Input, InputGroup, FormFeedback } from 'reactstrap';
import moment from 'moment';

import ParadigmaModal from "../../components/ParadigmaModal/ParadigmaModal.js"
import ParadigmaAsyncSeeker from "../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import ParadigmaLabeledInput from "../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js"
import ParadigmaCurrencyInput from "../../components/ParadigmaCurrencyInput/ParadigmaCurrencyInput.js"


class Modal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: null,
            // Expedientes
            objeto_id: null,
            fechaIngreso: moment(),
            //Cambio Estado
            estado_id: 0,
            estado: '',
            observaciones: '',
            archivo: null,
            archivo2: null,
            archivo3: null,
            notificar_entidad: false,
            nroOrden: '',
            postVariables: ['estado_id', 'estado', 'observaciones', 'archivo', 'archivo2', 'archivo3', 'fecharegistrada', 'notificar_entidad', 'nroOrden'],
            errors: [],
            lista_estados: [],
            tituloModal: '',
            labelarchivo: '',
            labelarchivo2: '',
            labelarchivo3: '',
            listVisacionesEncomiendaPrevia: [],
            isGoProcess: true,
            encomiendaRef: '',
            listaIdEstados: [],
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func,
        id: PropTypes.func,
        action: PropTypes.oneOf(['CREATE', 'EDIT', 'DETAIL', 'DELETE']).isRequired,
    }


    resetForm() {
        this.setState({
            id: null,
            fechaIngreso: moment(),
            //Cambio Estado
            estado: '',
            estado_id: 0,
            observaciones: '',
            archivo: null,
            archivo2: null,
            archivo3: null,
            notificar_entidad: false,
            errors: [],
            lista_estados: [],
            tituloModal: '',
            labelarchivo: '',
            labelarchivo2: '',
            labelarchivo3: '',
            listVisacionesEncomiendaPrevia: [],
            isGoProcess: true,
            encomiendaRef: '',
            listaIdEstados: [],
        });
    }

    getData() {
        const { precioUnitario, postVariables, fechaIngreso, estado, importePresupuesto, mostrarImporte, estado_id } = this.state;
        let data = {};
        postVariables.forEach(x => {
            data[x] = this.state[x];
        });
        data['fecharegistrada'] = fechaIngreso.format('YYYY-MM-DD');
        data['estado'] = this.searchEstadoVisacion(estado_id);
        return data;
    }

    searchEstadoVisacion(id) {
        const { lista_estados_r } = this.props;
        let estadoEncontrado = lista_estados_r.find(x => x.id == id);
        console.log(estadoEncontrado)
        if (estadoEncontrado) {
            return estadoEncontrado.nombre;
        }
        return null;
    }

    filtrarDesdePosicion(array, elementoInicial) {
        const indice = array.indexOf(elementoInicial);
        if (indice === -1) {
            console.log(`El elemento "${elementoInicial}" no existe en el array`);
            return [];
        }

        return array.slice(indice);
    }

    setData(data) {
        const { action, ar_estados, lista_estados_r } = this.props;
        const { lista_estados } = this.state;
        if (data.success) {
            let estado = data.estado;
            let indice = lista_estados.indexOf(estado);
            let filtr = lista_estados.slice(indice);
            let idEncomiendaPadre = data.encomiendaprofesional.id;
            let registrosEstados = data.estadosplantillas.listaestadosid
            let estadoActual = data.controlestados;
            console.log(data)
            if (action != 'DELETE') {
                let list_correlativos = data.lista_correlativos == null ? [] : data.lista_correlativos;
                apiFunctions.get(api.visaciones.listadovisacionesencomiendas, idEncomiendaPadre, null, null, (response) => {
                    console.log('dentro')
                    let registros = response.data
                    let visacionesFormateada = registros
                        .filter(registro => registro.id && list_correlativos.includes(registro.id))
                        .map((e) => ({
                            id: e.id,
                            nombre: e.estadosplantillas.nombre,
                            numero: e.estadosplantillas.numero,
                            estado: e.estado_id,
                            lista_estados: e.estadosplantillas.listaestadosid
                        }));

                    // Siempre configurar los estados disponibles basados en la plantilla actual
                    let newEstados = lista_estados_r.
                        filter(registro => registro.id && registrosEstados.includes(registro.id))
                        .map((e) => ({
                            id: e.id,
                            nombre: e.nombre,
                        }))

                    if (visacionesFormateada.length > 0) {
                        let existe = visacionesFormateada.some(e =>
                            e.estado == 'Previa' ||
                            e.estado == 'Observada'
                        );
                        this.setState({
                            listVisacionesEncomiendaPrevia: visacionesFormateada,
                            isGoProcess: !existe,
                            encomiendaRef: data.encomiendaprofesional.nroOrden,
                            lista_estados: newEstados
                        })
                    } else {
                        this.setState({
                            lista_estados: newEstados,
                            encomiendaRef: data.encomiendaprofesional.nroOrden
                        })
                    }
                });
            }

            this.setState({
                id: data.id,
                estado: data.estado,
                lista_estados: filtr,
                tituloModal: data.estadosplantillas.titulomodal,
                labelarchivo: data.estadosplantillas.labelarchivo,
                labelarchivo2: data.estadosplantillas.labelarchivo2 || '',
                labelarchivo3: data.estadosplantillas.labelarchivo3 || '',
                listaIdEstados: data.estadosplantillas.listaestadosid,
                estado_id: data.estado_id,
                nroOrden: data.nro_expediente || '',
            });

        }
    }

    setErrors(errors) {
        this.setState({
            errors: errors,
        });
    }

    onChangeField(field, value) {
        this.setState(prevState => {
            let errors = prevState.errors;
            if (errors) errors[field] = null;
            prevState.errors = errors;
            prevState[field] = value;
            return prevState;
        });
    }

    getError(field) {
        let errors = this.state.errors;
        if (errors) return errors[field];
        else return null;
    }

    modalVars() {
        const { estado, estadoAnterior, estadoARetroceder, lista_estados, tituloModal, isGoProcess } = this.state;
        const { action, ar_estados } = this.props;

        if (action == "EDIT") {
            return {
                get: true,
                submitType: "PUT",
                // asigno el titulo del modal dependiendo el estado (tituloModal)
                title: tituloModal == '' ? 'Avanzar visación' : tituloModal,
                buttonTitle: "Avanzar",
                danger: !isGoProcess,
                buttonIcon: "fa fa-share fa-lg",
                successMessage: "ha sido editado con éxito.",
                saveButton: isGoProcess,
                saveButtonLabel: "Guardar",
                buttonClass: "",
                disabled: false,
                id: this.props.id,
            };
        }
        else if (action == "DELETE") {
            return {
                get: true,
                submitType: "DELETE",
                // asigno el titulo del modal dependiendo el estado (tituloModal)
                // title: (ar_estados && ar_estados.filter((f) => f.id==estadoAnterior).length>0 && ar_estados.filter((f) => f.id==estadoAnterior)[0].sePuedeAvanzar==true) ? (ar_estados.filter((f) => f.id==estadoAnterior)[0].tituloModal) : ('Avanzar'),
                title: 'Retroceder Visación',
                buttonTitle: "Retroceder",
                danger: true,
                buttonIcon: "fa fa-mail-reply fa-lg",
                successMessage: "ha sido editado con éxito.",
                saveButton: (estadoARetroceder != ''),
                saveButtonLabel: "Confirmar",
                buttonClass: "",
                disabled: true,
                id: this.props.id,
            };
        } else if (action == "DETAIL") {
            return {
                get: true,
                submitType: null,
                title: 'Detalle de Visación',
                buttonTitle: "Cerrar",
                danger: false,
                buttonIcon: "fa fa-eye",
                successMessage: "",
                saveButton: false,
                saveButtonLabel: "",
                buttonClass: "",
                disabled: true,
                id: this.props.id,
                cancelButtonLabel: "Cerrar"
            };
        }
    }

    onValidation = () => {
        const { estadoAnterior, estado, observaciones, archivo } = this.state;
        const { action, ar_estados } = this.props;

        let errors = {};
        let valid = true;
        // if(action=='EDIT'){
        //     // Valido si el cambio de estado exige un archivo
        //     if(archivo==null){
        //         errors['archivo'] = [{code: "blank", detail: "Seleccione un archivo"}]
        //         valid = false;
        //     }
        // }

        this.setState({ errors: errors })

        return valid
    }

    selectComitente = (data) => {
        this.setState({
            comitente_id: (data) ? (data.id) : (null),
            telefono: (data) ? (data.telefono) : (''),
            telefono2: (data) ? (data.telefono2) : (''),
            telefono3: (data) ? (data.telefono3) : (''),
        })
    }

    changeValuesSelect = (data, listStatus) => {
        let res = listStatus.find(objeto => objeto.id == data.id);
        let valRes = false;
        if (res) {
            valRes = res.mostrarImporte;
        }
        this.setState({ estado: data.id, mostrarImporte: valRes })
    }

    render() {
        let vars = this.modalVars();
        const { action, ar_estados } = this.props;
        const { lista_estados, estadoAnterior, estado, estado_id, observaciones, encomiendaRef, archivo, archivo2, isGoProcess, labelarchivo, labelarchivo2, labelarchivo3, listVisacionesEncomiendaPrevia, notificar_entidad } = this.state;

        return (
            <ParadigmaModal
                getUrl={(vars.get ? api.visaciones.encomienda : null)}
                submitUrl={(vars.submitType ? api.visaciones.cambioestado : null)}
                submitType={vars.submitType}
                id={vars.id}
                onGotData={(data) => this.setData(data)}
                onGotErrors={(errors) => this.setErrors(errors)}
                onSubmit={(e) => this.props.onSubmit(e)}
                onClose={() => this.resetForm()}
                onPreSubmit={() => this.getData()}
                onValidation={() => this.onValidation()}
                cancelButtonLabel={vars.cancelButtonLabel}
                title={vars.title}
                danger={vars.danger}
                buttonClass={vars.buttonClass}
                successMessage={vars.successMessage}
                missingIdMessage={"Debe seleccionar una fila."}
                saveButtonLabel={vars.saveButtonLabel}
                buttonTitle={vars.buttonTitle}
                buttonIcon={vars.buttonIcon}
                saveButton={vars.saveButton}
                closeButton={true}
                // className={'modal-lg'}
                fileUploader
                escClose={true}
            >
                {(action == 'DETAIL') ?
                    <Fragment>
                        <ParadigmaLabeledInput
                            label={'N° Encomienda'}
                            md={[4, 8]}
                            inputComponent={
                                <Input
                                    type="text"
                                    value={encomiendaRef || ''}
                                    disabled={true}
                                />
                            }
                        />

                        <ParadigmaLabeledInput
                            label={'Estado'}
                            md={[4, 8]}
                            inputComponent={
                                <Input
                                    type="text"
                                    value={estado || ''}
                                    disabled={true}
                                />
                            }
                        />

                        <ParadigmaLabeledInput
                            label={'Visaciones Previas'}
                            md={[4, 8]}
                            inputComponent={
                                <ul className="list-group" style={{ width: '100%' }}>
                                    {Array.isArray(listVisacionesEncomiendaPrevia) && listVisacionesEncomiendaPrevia.length > 0 ? (
                                        listVisacionesEncomiendaPrevia.map((data, i) => (
                                            <li key={i} className="list-group-item d-flex justify-content-between align-items-center" style={{ padding: '0.375rem 0.75rem' }}>
                                                {data.numero} - {data.nombre}
                                                <span className={
                                                    'badge ' +
                                                    (data.estado === 'Definitiva'
                                                        ? 'badge-primary'
                                                        : 'badge-danger')
                                                }>{data.estado}</span>
                                            </li>
                                        ))
                                    ) : (
                                        <div className="text-muted py-2">
                                            No hay visaciones previas
                                        </div>
                                    )}
                                </ul>
                            }
                        />

                        <ParadigmaLabeledInput
                            label={'Observaciones'}
                            md={[4, 8]}
                            inputComponent={
                                <Input
                                    type="textarea"
                                    value={observaciones || ''}
                                    disabled={true}
                                    className="ta_m_movil"
                                />
                            }
                        />

                        {/* Archivos si existen */}
                        {labelarchivo && (
                            <ParadigmaLabeledInput
                                label={"Doc. 1 - " + labelarchivo}
                                md={[4, 8]}
                                inputComponent={
                                    <div className="form-control-plaintext">
                                        {(archivo) ? 'Archivo cargado' : 'Sin archivo'}
                                        {/* Nota: En modo detalle la carga de archivo no muestra el archivo en sí mismo si no viene del back como URL, 
                                            pero aquí 'archivo' en state suele ser el objeto File en edición. 
                                            En detalle vendría de 'data' en setData.
                                            Como es una vista de detalle, asumimos que mostramos lo que hay. 
                                            Si 'archivo' es null, no hay archivo. 
                                            TODO: Si el back devuelve URL, mostrar link. Por ahora simple texto.
                                        */}
                                    </div>
                                }
                            />
                        )}

                    </Fragment>
                    :
                    (action != 'DELETE' && isGoProcess) ?

                        <Fragment>
                            {/* Si se puede avanzar a mas de un estado, se muestra un asyncseeker para elegir el estado a avanzar */}
                            <ParadigmaLabeledInput
                                label={'Avanzar a'}
                                md={[4, 8]}
                                inputComponent={
                                    <ParadigmaAsyncSeeker
                                        url={undefined}
                                        clearable={false}
                                        optionDefault={lista_estados.filter(e => e.nombre !== 'Creado').map(e => { return { nombre: e.nombre, id: e.id } })}
                                        value={estado_id}
                                        onChange={e => this.setState({ estado_id: e.id })}
                                    />
                                }
                                error={() => this.getError('estado_id')}
                            />

                            {/* Mostrar campo N° Expediente (nroOrden) si se avanza de Creado a Inicio */}
                            {(() => {
                                // Obtener nombre del estado actual
                                // 'estado' puede ser un ID o el nombre. Intentamos buscar el objeto.
                                let nombreEstadoActual = '';

                                // Intentar buscar en ar_estados (props) o lista_estados (state)
                                let listasBusqueda = [this.props.ar_estados, this.state.lista_estados, this.props.lista_estados_r].filter(l => l && l.length > 0);
                                for (let lista of listasBusqueda) {
                                    let encontrado = lista.find(e => e.id == this.state.estado);
                                    if (encontrado) {
                                        nombreEstadoActual = encontrado.nombre;
                                        break;
                                    }
                                }

                                // Si no se encontró por ID, y estado es un string, asumimos que es el nombre
                                if (!nombreEstadoActual && typeof this.state.estado === 'string') {
                                    nombreEstadoActual = this.state.estado;
                                }

                                // Obtener nombre del estado seleccionado (destino)
                                let nombreEstadoSiguiente = '';
                                if (this.state.lista_estados && this.state.lista_estados.length > 0) {
                                    let estadoSiguienteObj = this.state.lista_estados.find(e => e.id == this.state.estado_id);
                                    if (estadoSiguienteObj) nombreEstadoSiguiente = estadoSiguienteObj.nombre;
                                }

                                if (nombreEstadoActual && typeof nombreEstadoActual === 'string' && nombreEstadoSiguiente && typeof nombreEstadoSiguiente === 'string' &&
                                    nombreEstadoActual.toLowerCase() === 'creado' &&
                                    nombreEstadoSiguiente.toLowerCase() === 'inicio') {
                                    return (
                                        <ParadigmaLabeledInput
                                            label={'N° Expediente'}
                                            md={[4, 8]}
                                            inputComponent={
                                                <Input
                                                    id={'inp_nroOrden'}
                                                    onChange={e => this.onChangeField('nroOrden', e.target.value)}
                                                    type="text"
                                                    value={this.state.nroOrden}
                                                    maxLength={50}
                                                    disabled={false}
                                                />
                                            }
                                            error={() => this.getError('nroOrden')}
                                        />
                                    );
                                }
                                return null;
                            })()}

                            <ParadigmaLabeledInput
                                label={"Doc. 1 - " + labelarchivo}
                                md={[4, 8]}
                                inputComponent={
                                    <Input
                                        id={'inp_arch'}
                                        onChange={e => this.setState({ archivo: e.target.files[0] })}
                                        type="file"
                                        disabled={vars.disabled}
                                    />
                                }
                                error={() => this.getError('archivo')}
                            />

                            {labelarchivo2 && labelarchivo2.trim() !== '' && (
                                <ParadigmaLabeledInput
                                    label={"Doc. 2 - " + labelarchivo2}
                                    md={[4, 8]}
                                    inputComponent={
                                        <Input
                                            id={'inp_arch2'}
                                            onChange={e => this.setState({ archivo2: e.target.files[0] })}
                                            type="file"
                                            disabled={vars.disabled}
                                        />
                                    }
                                    error={() => this.getError('archivo2')}
                                />
                            )}

                            {labelarchivo3 && labelarchivo3.trim() !== '' && (
                                <ParadigmaLabeledInput
                                    label={"Doc. 3 - " + labelarchivo3}
                                    md={[4, 8]}
                                    inputComponent={
                                        <Input
                                            id={'inp_arch3'}
                                            onChange={e => this.setState({ archivo3: e.target.files[0] })}
                                            type="file"
                                            disabled={vars.disabled}
                                        />
                                    }
                                    error={() => this.getError('archivo3')}
                                />
                            )}

                            <ParadigmaLabeledInput
                                md={[4, 8]}
                                type={'textarea'}
                                label={"Observaciones"}
                                classNames={['', 'ta_m_movil']}
                                value={observaciones}
                                maxLength={255}
                                onChange={(e) => this.onChangeField('observaciones', e.target.value)}
                                error={() => this.getError('observaciones')}
                            />

                            <Row>
                                <label style={{ width: "100%", display: "flex" }}>
                                    <Col md={4} >
                                        {' Notificar a Entidad'}
                                    </Col>
                                    <Col md={8}>
                                        <input
                                            style={{ marginLeft: "auto" }}
                                            type="checkbox"
                                            checked={notificar_entidad}
                                            onChange={(e) => this.onChangeField('notificar_entidad', e.target.checked)}
                                        />
                                    </Col>
                                </label>
                            </Row>
                        </Fragment>
                        :
                        (!isGoProcess) ?
                            <Fragment>
                                <h4 className='text-center' >Listado de visaciones</h4><br></br>
                                <h5 className='text-center' > Encomienda Ref: {encomiendaRef} </h5><br></br>
                                <strong className={'text-center'}>No se puede completar la operación solicitada. Existen visaciones previas pendientes de finalización en el registro actual.</strong>
                                <ul className="list-group">
                                    {Array.isArray(listVisacionesEncomiendaPrevia) && listVisacionesEncomiendaPrevia.length > 0 ? (
                                        listVisacionesEncomiendaPrevia.map((data, i) => (
                                            <li key={i} className="list-group-item d-flex justify-content-between align-items-center">
                                                {data.numero} - {data.nombre}
                                                <span className={
                                                    'badge ' +
                                                    (data.estado === 'Definitiva'
                                                        ? 'badge-primary'
                                                        : 'badge-danger')
                                                }>{data.estado}</span>
                                            </li>
                                        ))
                                    ) : (
                                        <div className="text-muted text-center py-3">
                                            No hay visaciones registradas
                                        </div>
                                    )}
                                </ul>

                            </Fragment>
                            :
                            <h2 className={'text-center'}>{(estado != 'Previa') ? 'Retroceder al estado "' + (estado == 'Definitiva' ? 'Observada' : 'Previa') + '"' : ('No se puede retroceder la visación')}</h2>
                }
            </ParadigmaModal>
        );
    }
}

export default Modal;


// WEBPACK FOOTER //
// ./src/views/VisacionesEncomienda/CambioEstado.js